module.exports = __webpack_public_path__ + "img/icon-device.936b6cdb.svg";